module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [(_vm.$route.meta.registerComponent == 'Live' || _vm.$route.meta.registerComponent == 'Upgrade-live') ? _c('live', {
    attrs: {
      "translations": _vm.translations,
      "step": _vm.step,
      "legalType": _vm.legalType,
      "upgrade": _vm.upgrade
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.meta.registerComponent == 'Demo') ? _c('demo', {
    attrs: {
      "translations": _vm.translations,
      "step": _vm.step,
      "legalType": _vm.legalType
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.meta.registerComponent == 'Partner') ? _c('partner', {
    attrs: {
      "translations": _vm.translations,
      "step": _vm.step,
      "legalType": _vm.legalType
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-699e8208"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/register/Base.vue
// module id = 775
// module chunks = 0